import { useState } from "react";
import { useIntl } from "react-intl";
import isEmpty from "lodash/fp/isEmpty";
import TreeCategory from "@rio-cloud/rio-uikit/TreeCategory";
import UptimeSidebar from "./UptimeSidebar";
import InfoDialog from "../dialogs/InfoDialog";

import useAssets from "../../hooks/useAssets";

import "./styles.scss";

const CATEGORY_FILTER = "filter";
const CATEGORY_ASSETS = "assets";

interface IAssetsTreeProps {
  assetIds: string[];
  groupIds: string[];
  setAssetIds: (assetIds: string[]) => void;
  setGroupIds: (groupIds: string[]) => void;
  selectionLimit?: number;
}

const AssetTreeSidebar = (props: IAssetsTreeProps) => {
  const intl = useIntl();

  const { allAssets, allGroups } = useAssets();
  const [error] = useState<string | null>(null);
  const [showLimitDialog, setShowLimitDialog] = useState(false);

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="display-flex flex-wrap gap-25 overflow-auto">
      <div className="w-full" style={{ height: 'calc(100vh - 50px)' }}>
        <TreeCategory
          key={CATEGORY_FILTER}
          id={CATEGORY_FILTER}
          label="Filter"
          icon="rioglyph-filter"
        />

        <TreeCategory
          key={CATEGORY_ASSETS}
          id={CATEGORY_ASSETS}
          label="Assets"
          icon="rioglyph-truck"
          hasSelection={!isEmpty(props.assetIds) || !isEmpty(props.groupIds)}
        >
          <UptimeSidebar
            allAssets={allAssets}
            allGroups={allGroups}
            setAssetIds={props.setAssetIds}
          />
        </TreeCategory>
      </div>

      <InfoDialog 
        show={showLimitDialog}
        title={intl.formatMessage({ id: 'intl-msg:assetsTree.maxSelectionLimit' })}
        body={intl.formatMessage({ id: 'intl-msg:assetsTree.maxSelectionLimitBody' }, { limit: props.selectionLimit })}
        onClose={() => setShowLimitDialog(false)}
      />
    </div>
  );
};

export default AssetTreeSidebar;
